import ServiceTemplate from '@/components/ServiceTemplate';

export default function CompanyDissolution() {
  const data = {
    title: 'Company Dissolution Services',
    subtitle: 'Professional business dissolution and closure services to properly wind down your company.',
    overviewTitle: 'Properly Dissolving Your Business',
    overviewImage: 'https://images.pexels.com/photos/7876000/pexels-photo-7876000.jpeg',
    description: [
      'Properly dissolving a business is crucial to avoid ongoing tax obligations, legal liabilities, and personal liability for unpaid debts. Formal dissolution with the state protects owners from future claims.',
      'Our dissolution service handles all required filings, tax clearances, creditor notifications, and asset distributions to ensure your business is properly closed and all loose ends are tied up.',
      'We guide you through the entire dissolution process, ensuring compliance with state requirements and protecting owners from ongoing liability.'
    ],
    benefits: [
      { title: 'Liability Protection', description: 'Properly terminate business existence and limit liability.' },
      { title: 'Tax Closure', description: 'Close tax accounts and prevent ongoing tax obligations.' },
      { title: 'Compliance', description: 'Meet all state dissolution requirements.' },
      { title: 'Asset Distribution', description: 'Properly distribute remaining assets to owners.' },
      { title: 'Creditor Protection', description: 'Follow proper procedures for creditor notification.' },
      { title: 'Clean Closure', description: 'Achieve complete business closure.' }
    ],
    process: [
      { title: 'Assessment & Planning', description: 'Evaluate current status and plan all necessary steps for successful completion.' },
      { title: 'Documentation & Filing', description: 'Prepare and file all required documents with state and federal authorities.' },
      { title: 'Verification & Finalization', description: 'Ensure proper processing, obtain confirmations, and finalize all requirements.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'Why can\'t I just stop doing business?', answer: 'Inactive businesses remain legally active, requiring annual reports and fees. Proper dissolution terminates legal existence and obligations.' },
      { question: 'What happens to business debts?', answer: 'Debts must be paid or settled before dissolution. Owners may be personally liable for unpaid debts in some circumstances.' },
      { question: 'How long does dissolution take?', answer: 'The process typically takes 2-4 months including creditor notification periods and state processing time.' },
      { question: 'What if my business owes taxes?', answer: 'Tax obligations must be resolved before dissolution. We can help negotiate payment plans or settlements with tax authorities.' },
      { question: 'Can I dissolve if I have employees?', answer: 'Yes, but you must properly terminate employment, file final payroll returns, and comply with employee notification requirements.' },
      { question: 'What about business assets?', answer: 'Assets are distributed to pay debts first, then remaining assets are distributed to owners according to ownership percentages.' },
      { question: 'Do I need to notify customers?', answer: 'While not legally required, notifying customers and business contacts is good practice to maintain professional relationships.' },
      { question: 'What happens to business licenses?', answer: 'All business licenses should be cancelled or transferred as part of the dissolution process.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
